export const KPIS_WIDGET_NAMESPACE = 'widget.kpis'
